module.exports = __webpack_public_path__ + "static/media/skiing.09d8b30d.svg";